// extracted by mini-css-extract-plugin
export default {"element":"OrderIngredientImage_element__6ZB8g","image":"OrderIngredientImage_image__45uXk","text":"OrderIngredientImage_text__vqbDA"};